import { Settings } from "@/components/Settings/types/settings";
import { z } from "zod";

const DomesticPeriodsSchema = z.object({
  installationType: z.literal('domestic'),
  periods: z.tuple([
    z.number().positive('common:text.required_field'),
    z.number().positive('common:text.required_field')
  ])
  .refine(
    periods => {
      return periods[0] <= periods[1]
    }, 
    {
      path: [1], 
      message: 'common:text.field_must_be_greater_than_previous_field'
    }
  )
})

export const IndustrialPeriodsSchema = z.object({
  installationType: z.literal('industrial'),
  periods: z.tuple([
    z.number().positive('common:text.required_field'),
    z.number().positive('common:text.required_field'),
    z.number().positive('common:text.required_field'),
    z.number().positive('common:text.required_field'),
    z.number().positive('common:text.required_field'),
    z.number().positive('common:text.required_field')
  ]).superRefine((periods, ctx) => {
    for (let i = 0; i < periods.length - 1; i++) {
      if (i < periods.length && periods[i+1] < periods[i]) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "common:text.field_must_be_greater_than_previous_field",
          path: [i+1],
        });
      }
    }
  })
})

const PeriodsSchema = z.discriminatedUnion("installationType", [
  DomesticPeriodsSchema,
  IndustrialPeriodsSchema
])

const PowersSchema = z.discriminatedUnion("change", [
  z.object({
    change: z.literal(false),
    current: PeriodsSchema
  }),
  z.object({
    change: z.literal(true),
    current: PeriodsSchema,
    new: PeriodsSchema
  })
])

export const SelfconsSchema = (
  requireDocumentation: boolean = true
) => (
  z.discriminatedUnion("enabled", [
    z.object({enabled: z.literal(false)}),
    z.object({
      enabled: z.literal(true),
      code: z.string(),
      attachments: z.object({
        name: z.string(),
        content: z.string().regex(
          /^data:.*\/[a-zA-Z]+;base64,/, 
          'common:text.invalid_attachment_type'
        )
      })
      .array()
      .min(requireDocumentation ? 1 : 0, 'common:text.required_field')
    }),
  ])
);

export const FormContractSchema = (settings: Settings) => z.object({
  powers: PowersSchema,

  accessTariff: z.object({
    id: z.number().nonnegative({message: 'common:text.required_field'}),
    name: z.string().optional(),
  }),

  product: z.object({
    id: z.number({
      invalid_type_error: 'common:text.required_field'
    }).positive({message: 'common:text.required_field'}),
    name: z.string().optional(),
  }),

  promotionalCode: z.string().array(),

  selfcons: SelfconsSchema(settings.contractation?.electricity?.selfcons?.requireDocumentation)
});
